import React, { useEffect, useState } from 'react'
import Shop_Nav from './Shop_Nav'
import Details from './Details'
import { useParams } from 'react-router'
import {itemData} from '../temp_assets/itemData'
import { useDispatch } from 'react-redux'
import { fetchItemByIdThunk } from '../thunks/thunks'

const Item = () => {
    const {id} = useParams();
    //fetch by id api 
    const dispatch = useDispatch();
    const [item, setItem] = useState(null);
    const [loading,setLoading] = useState(true);
    console.log("item",item);
    useEffect(()=>{
      const fetchData = async () => {
        try {
            const response = await dispatch(fetchItemByIdThunk(id));
            setItem(response.payload);
        } catch (error) {
            console.error('Error fetching item:', error);
        } finally {
            setLoading(false);
        }
      };
      fetchData();
    },[dispatch,id]);

    console.log("item: ",item);
    if(!item){
        return <h1>Item not found</h1>
    }
  return (
    <div>
      <Shop_Nav/>
      <Details item={item}/>
    </div>
  )
}

export default Item
